const subscribe = (store) => {};

export default {
  subscribe,
};
